import { Vue, Component, Prop } from "vue-property-decorator";

import { authService } from "@/services/authService";

import MainHeader from "./components/main-header/main-header.vue";
import Modal from "@/components/modal/modal.vue";
import MainMap from "./components/maps/maps.vue"

@Component({ components: { MainHeader, Modal, MainMap } })
export default class MapHome extends Vue {
    @Prop({ default: null, required: false })
    layerId?: string

    authenticated: boolean = false;
    sessionChecked: boolean = false;
    authenticating: boolean = false;
    credentials: { username: string, password: string, error: boolean } = { username: "", password: "", error: false };

    async created() {
        this.authenticated = await authService.isAuthorized();
        this.sessionChecked = true;
    }

    get tab() {
        return this.$route?.query?.tab ?? 'description';
    }

    async login() {
        this.authenticating = true;
        this.authenticated = await authService.login(this.credentials.username, this.credentials.password);
        this.authenticating = false;
        this.credentials.error = !this.authenticated;

        if (this.authenticated) {
            this.credentials = { username: "", password: "", error: false };
        }
    }

    onLogout() {
        authService.logout();
        this.authenticated = false;
    }
}